export const ARTICLE_PATH = "/article";
export const ARTICLES_LIST_PATH = "/articles";
export const ARTICLE_ROUTE_PATH = `${ARTICLE_PATH}/:articleId/:slug?`;
